/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { Trans } from "react-i18next";

import ForumOutlineIcon from "@/assets/customIcons/contacts/ForumOutlineIcon";

import { InfoOutlineIcon } from "@dotnet/telematics-design-system";

import LogoIcon from "../../../assets/customIcons/contacts/LogoIcon";
import TextLink from "../../../components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../components/TextLink/types";
import { useStyles } from "../styles";
import IconLink from "./IconLink";

const Contacts = () => {
  const { contactsOuterDiv, privacyPolicyDiv, contactIconsDiv } = useStyles();

  return (
    <div css={css(contactsOuterDiv)}>
      <div css={css(privacyPolicyDiv)}>
        <Trans
          i18nKey="Auth##privacy policy"
          components={{
            3: (
              <TextLink
                href="https://teltonika-iot-group.com/policies-certificates/privacy-policy"
                target="_blank"
                rel="noreferrer"
                underline="none"
                size={TEXT_LINK_SIZES.Small}
              />
            )
          }}
        />
      </div>

      <div css={css(contactIconsDiv)}>
        <IconLink
          dataTestId="logo-icon"
          link="https://teltonika-gps.com/"
          tooltip="teltonika telematics"
          icon={LogoIcon}
        />

        <IconLink
          dataTestId="community-forum-icon"
          link="https://community.teltonika.lt/"
          tooltip="community forum"
          icon={ForumOutlineIcon}
        />

        <IconLink
          dataTestId="wiki-icon"
          link="https://wiki.teltonika-gps.com/view/TachoSync"
          tooltip="wiki"
          icon={InfoOutlineIcon}
        />
      </div>
    </div>
  );
};

export default Contacts;
